import * as React from "react"
const IconColumns = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 20}
        height={props.height || 20}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <path
            stroke={props.stroke || "#A4A7AE"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={props.strokeWidth || 1.667}
            d="M5.667 2.5h-.5c-.934 0-1.4 0-1.757.182-.314.16-.569.414-.728.728-.182.357-.182.823-.182 1.757v9.666c0 .934 0 1.4.182 1.757.16.314.414.569.728.728.357.182.823.182 1.757.182h.5c.933 0 1.4 0 1.756-.182.314-.16.569-.414.729-.728.181-.357.181-.823.181-1.757V5.167c0-.934 0-1.4-.181-1.757a1.667 1.667 0 0 0-.729-.728C7.067 2.5 6.6 2.5 5.667 2.5ZM14.833 2.5h-.5c-.933 0-1.4 0-1.756.182-.314.16-.569.414-.729.728-.181.357-.181.823-.181 1.757v9.666c0 .934 0 1.4.181 1.757.16.314.415.569.729.728.356.182.823.182 1.756.182h.5c.934 0 1.4 0 1.757-.182.314-.16.569-.414.728-.728.182-.357.182-.823.182-1.757V5.167c0-.934 0-1.4-.182-1.757a1.666 1.666 0 0 0-.728-.728c-.357-.182-.823-.182-1.757-.182Z"
        />
    </svg>
)
export default IconColumns
